import { useFormikContext } from "formik";

import { AdvancedCreatorSearchModal } from "@/features/creators/components/AdvancedCreatorSearchModal";

interface AssignmentAdvancedCreatorSearchWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  campaign_id?: string;
}

/**
 * Wrapper component that integrates AdvancedCreatorSearchModal with Formik context
 * specifically for assignment creation forms.
 * Uses Formik hooks to automatically update form values when a creator is selected.
 */
export const AssignmentAdvancedCreatorSearchWrapper = ({
  isOpen,
  onClose,
  campaign_id,
}: AssignmentAdvancedCreatorSearchWrapperProps) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const handleCreatorSelected = (creatorId: string) => {
    setFieldValue("creator_id", creatorId);
    setFieldTouched("creator_id", true);
    onClose();
  };

  return (
    <AdvancedCreatorSearchModal
      isOpen={isOpen}
      onClose={onClose}
      onSelectCreator={handleCreatorSelected}
      campaign_id={campaign_id}
      preSelectedCreatorId={""} // Fresh selection each time
    />
  );
};
